import pre_designed_template3 from "../../../assests/Images/TemplateElement/pre_designed_template3.png";
import { DATE } from "../../../shared/constants.js";
import CardTemplate from "./CardTemplate";

function PreDefineTemplate3({ heading, date, journalId,pageRefresh,ref,menuShow}) {
  return (
    <CardTemplate
      journalId={journalId}
      headingText={heading}
      date={date || DATE.JOURNAL_FORMAT}
      bgColor="#0ae2cd"
      headingColor="#000000"
      textColor="#ffffff"
      textSize={{ xs: "1.1rem", sm: "1.2rem", md: "1.2rem" }}
      widthSize={{ xs: "55%", sm: "55%", md: "55%" }}
      imageTopLeft={pre_designed_template3}
      imageTopLeftStyle={{ width: 70, height: 70, top: 10, left: 10, transform: "rotate(150deg)" }}
      headingMargin={{ xs: "40%", sm: "45%", md: "45%" }}
      pageRefreshCallback={pageRefresh}
      ref={ref}
      menuShow={menuShow}
    />
  );
}

export default PreDefineTemplate3;
